// @ts-ignore
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
export const CatalogueVideoFragmentDoc = gql`
    fragment catalogueVideo on CatalogueVideo {
  __typename
  uri
  type
}
    `;